import PortalFooter from './PortalFooter';

export default PortalFooter;
